export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', count: 128 },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', count: 96 },
  { slug: 'xiuzhen', name: '修真', icon: 'ri-sword-line', count: 84 },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', count: 112 },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', count: 56 },
  { slug: 'xuanhuan-2', name: '悬疑', icon: 'ri-search-eye-line', count: 43 },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 78 },
  { slug: 'aiqing', name: '恋爱', icon: 'ri-heart-line', count: 65 },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-line', count: 52 },
  { slug: 'zhanzheng', name: '战争', icon: 'ri-shield-flash-line', count: 31 },
];

export const comics = [
  {
    id: 1,
    slug: 'quanzhi-fashi',
    title: '全职法师',
    author: '乱',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20young%20male%20mage%20wearing%20modern%20school%20uniform%20with%20magical%20energy%20surrounding%20him%2C%20dynamic%20pose%2C%20warm%20orange%20and%20gold%20tone%2C%20manga%20cover%20art%20style%2C%20clean%20composition%2C%20soft%20gradient%20background%20with%20magical%20runes&width=800&height=1100&seq=comic-quanzhi-fashi&orientation=portrait',
    description: '一觉醒来，世界巨变。曾经繁华的都市如今妖魔横行，人们躲在冰冷的钢铁城墙之后惶惶不可终日。然而，在这绝望的时代，人类觉醒了神奇的力量——魔法。当莫凡睁开双眼，发现自己穿越到了这个魔法为尊的世界，一场属于全职法师的传奇冒险即将展开。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    tags: ['热血', '玄幻', '穿越', '战斗', '校园'],
    status: 'ongoing',
    rating: 9.6,
    views: 12890000,
    chapters: [
      { id: 1, number: 1, title: '第1话 觉醒之日', updatedAt: '2026-06-28' },
      { id: 2, number: 2, title: '第2话 元素初现', updatedAt: '2026-06-27' },
      { id: 3, number: 3, title: '第3话 雷系觉醒', updatedAt: '2026-06-24' },
      { id: 4, number: 4, title: '第4话 校园风云', updatedAt: '2026-06-21' },
      { id: 5, number: 5, title: '第5话 第一次实战', updatedAt: '2026-06-18' },
      { id: 6, number: 6, title: '第6话 魔法考核', updatedAt: '2026-06-15' },
      { id: 7, number: 7, title: '第7话 暗流涌动', updatedAt: '2026-06-12' },
      { id: 8, number: 8, title: '第8话 星辰之力', updatedAt: '2026-06-09' },
      { id: 9, number: 9, title: '第9话 冰火双修', updatedAt: '2026-06-06' },
      { id: 10, number: 10, title: '第10话 巅峰对决', updatedAt: '2026-06-03' },
      { id: 11, number: 11, title: '第11话 远古遗迹', updatedAt: '2026-05-30' },
      { id: 12, number: 12, title: '第12话 深渊试炼', updatedAt: '2026-05-27' },
    ],
    featured: true,
  },
  {
    id: 2,
    slug: 'tunshi-xingkong',
    title: '吞噬星空',
    author: '我吃西红柿',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20illustration%20of%20a%20young%20warrior%20in%20futuristic%20armor%20holding%20a%20sword%2C%20cosmic%20background%20with%20stars%20and%20nebula%2C%20manga%20cover%20style%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20clean%20composition%20with%20soft%20lighting&width=800&height=1100&seq=comic-tunshi-xingkong&orientation=portrait',
    description: '公元2066年，经历大涅槃时期后，地球人类开始修炼进化，武者成为时代主角。少年罗峰在高考前夕，意外获得陨墨星传承，从此踏上一段吞噬星空的传奇征程。',
    category: '科幻',
    categorySlug: 'kehuan',
    tags: ['科幻', '进化', '热血', '战斗'],
    status: 'ongoing',
    rating: 9.4,
    views: 8920000,
    chapters: [
      { id: 1, number: 1, title: '第1话 大涅槃之后', updatedAt: '2026-06-26' },
      { id: 2, number: 2, title: '第2话 陨墨星传承', updatedAt: '2026-06-23' },
      { id: 3, number: 3, title: '第3话 武者之路', updatedAt: '2026-06-20' },
    ],
    featured: true,
  },
  {
    id: 3,
    slug: 'doupo-cangqiong',
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20illustration%20of%20a%20handsome%20young%20man%20in%20ancient%20Chinese%20robe%20wielding%20flame%20energy%2C%20dramatic%20pose%2C%20warm%20golden%20and%20red%20tone%2C%20manga%20cover%20art%2C%20clean%20white%20background%20with%20fire%20effects&width=800&height=1100&seq=comic-doupo-cangqiong&orientation=portrait',
    description: '这里是属于斗气的世界，没有花俏艳丽的魔法，有的仅仅是繁衍到巅峰的斗气！少年萧炎在创造了家族空前绝后的修炼纪录后，突然成为了废人。种种打击接踵而至，就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    tags: ['玄幻', '热血', '修炼', '逆袭'],
    status: 'ongoing',
    rating: 9.5,
    views: 15670000,
    chapters: [
      { id: 1, number: 1, title: '第1话 陨落的天才', updatedAt: '2026-06-29' },
      { id: 2, number: 2, title: '第2话 戒指中的灵魂', updatedAt: '2026-06-26' },
      { id: 3, number: 3, title: '第3话 炼药师', updatedAt: '2026-06-23' },
      { id: 4, number: 4, title: '第4话 云岚宗', updatedAt: '2026-06-20' },
    ],
    featured: true,
  },
  {
    id: 4,
    slug: 'yiren-zhi-xia',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20modern%20supernatural%20illustration%20of%20a%20young%20man%20with%20mysterious%20aura%2C%20urban%20background%20with%20traditional%20elements%2C%20manga%20cover%20style%2C%20green%20and%20dark%20tone%2C%20clean%20composition&width=800&height=1100&seq=comic-yiren-zhixia&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急功近利的他在寻找秘密的过程中，却发现了异人世界的惊天阴谋。',
    category: '都市',
    categorySlug: 'dushi',
    tags: ['都市', '异能', '悬疑', '热血'],
    status: 'ongoing',
    rating: 9.3,
    views: 10230000,
    chapters: [
      { id: 1, number: 1, title: '第1话 异人出现', updatedAt: '2026-06-27' },
      { id: 2, number: 2, title: '第2话 冯宝宝', updatedAt: '2026-06-24' },
      { id: 3, number: 3, title: '第3话 罗天大醮', updatedAt: '2026-06-21' },
    ],
    featured: true,
  },
  {
    id: 5,
    slug: 'wanmei-shijie',
    title: '完美世界',
    author: '辰东',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20illustration%20of%20a%20young%20boy%20with%20determined%20expression%20in%20tribal%20clothing%2C%20ancient%20fantasy%20setting%20with%20beasts%2C%20manga%20cover%20style%2C%20earthy%20brown%20and%20gold%20tone%2C%20clean%20composition&width=800&height=1100&seq=comic-wanmei-shijie&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？一个少年从大荒中走出，一切从这里开始。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    tags: ['玄幻', '修炼', '热血', '史诗'],
    status: 'ongoing',
    rating: 9.2,
    views: 7560000,
    chapters: [
      { id: 1, number: 1, title: '第1话 大荒少年', updatedAt: '2026-06-25' },
      { id: 2, number: 2, title: '第2话 骨文', updatedAt: '2026-06-22' },
    ],
    featured: false,
  },
  {
    id: 6,
    slug: 'zhen-hun-jie',
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20illustration%20of%20a%20young%20man%20in%20modern%20clothing%20with%20guardian%20spirit%20behind%20him%2C%20dark%20urban%20fantasy%20style%2C%20dramatic%20lighting%2C%20manga%20cover%20art%2C%20deep%20purple%20and%20gold%20tone&width=800&height=1100&seq=comic-zhen-hun-jie&orientation=portrait',
    description: '镇魂街，此乃吸纳亡灵镇压恶灵之地。一人一守护灵，在这条充满危险与未知的街道上，少年曹焱兵与他的守护灵许褚，共同守卫着镇魂街的和平。',
    category: '热血',
    categorySlug: 'rexue',
    tags: ['热血', '奇幻', '冒险', '战斗'],
    status: 'ongoing',
    rating: 9.1,
    views: 6230000,
    chapters: [
      { id: 1, number: 1, title: '第1话 镇魂将至', updatedAt: '2026-06-24' },
      { id: 2, number: 2, title: '第2话 守护灵许褚', updatedAt: '2026-06-21' },
    ],
    featured: false,
  },
  {
    id: 7,
    slug: 'xingyu-ji',
    title: '星域纪',
    author: '暗夜幽殇',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20space%20adventure%20illustration%20of%20a%20young%20female%20captain%20in%20futuristic%20space%20suit%2C%20starship%20bridge%20background%2C%20manga%20cover%20style%2C%20blue%20and%20silver%20tone%2C%20clean%20composition&width=800&height=1100&seq=comic-xingyu-ji&orientation=portrait',
    description: '遥远的未来，人类文明遍布星域。少女林星瑶继承父亲的遗志，驾驶星际飞船「追光号」踏上探索未知星域的冒险之旅。',
    category: '科幻',
    categorySlug: 'kehuan',
    tags: ['科幻', '冒险', '星际', '机甲'],
    status: 'ongoing',
    rating: 8.9,
    views: 4120000,
    chapters: [
      { id: 1, number: 1, title: '第1话 追光号起航', updatedAt: '2026-06-20' },
    ],
    featured: false,
  },
  {
    id: 8,
    slug: 'jian-lai',
    title: '剑来',
    author: '烽火戏诸侯',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sword%20fantasy%20illustration%20of%20a%20young%20swordsman%20in%20traditional%20Chinese%20robe%20with%20flying%20sword%2C%20mountain%20landscape%20background%2C%20manga%20cover%20art%2C%20ink%20wash%20painting%20style%2C%20black%20and%20white%20with%20red%20accents&width=800&height=1100&seq=comic-jian-lai&orientation=portrait',
    description: '大千世界，无奇不有。我陈平安，唯有一剑，可搬山，倒海，降妖，镇魔，敕神，摘星，断江，摧城，开天！',
    category: '修真',
    categorySlug: 'xiuzhen',
    tags: ['修真', '剑修', '热血', '仙侠'],
    status: 'ongoing',
    rating: 9.5,
    views: 9890000,
    chapters: [
      { id: 1, number: 1, title: '第1话 少年陈平安', updatedAt: '2026-06-28' },
      { id: 2, number: 2, title: '第2话 泥瓶巷', updatedAt: '2026-06-25' },
      { id: 3, number: 3, title: '第3话 搬山猿', updatedAt: '2026-06-22' },
    ],
    featured: false,
  },
  {
    id: 9,
    slug: 'linglong',
    title: '玲珑',
    author: '花溟',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20romance%20fantasy%20illustration%20of%20a%20beautiful%20young%20woman%20in%20ancient%20Chinese%20dress%20with%20cherry%20blossoms%2C%20soft%20pink%20and%20gold%20tone%2C%20manga%20cover%20style%2C%20clean%20elegant%20composition&width=800&height=1100&seq=comic-linglong&orientation=portrait',
    description: '玲珑骰子安红豆，入骨相思知不知。少女苏玲珑意外穿越到古代宫廷，为了寻找回到现代的方法，她必须在尔虞我诈的后宫中找到那颗传说中的玲珑骰子。',
    category: '恋爱',
    categorySlug: 'aiqing',
    tags: ['恋爱', '穿越', '古风', '宫斗'],
    status: 'ongoing',
    rating: 8.7,
    views: 5340000,
    chapters: [
      { id: 1, number: 1, title: '第1话 穿越时空', updatedAt: '2026-06-22' },
    ],
    featured: false,
  },
  {
    id: 10,
    slug: 'lingshi',
    title: '灵师',
    author: '墨染',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20illustration%20of%20a%20mysterious%20young%20man%20with%20spirit%20energy%20glowing%20around%20his%20hands%2C%20dark%20supernatural%20setting%2C%20manga%20cover%20art%2C%20teal%20and%20dark%20green%20tone%2C%20clean%20composition&width=800&height=1100&seq=comic-lingshi&orientation=portrait',
    description: '在这个灵气复苏的时代，有一种被称为「灵师」的职业，他们能沟通阴阳、驱使鬼神。普通大学生陈墨意外觉醒了灵师天赋，踏上了游走于阴阳两界的冒险之旅。',
    category: '悬疑',
    categorySlug: 'xuanhuan-2',
    tags: ['悬疑', '灵异', '冒险', '都市'],
    status: 'ongoing',
    rating: 8.8,
    views: 3670000,
    chapters: [
      { id: 1, number: 1, title: '第1话 阴阳眼', updatedAt: '2026-06-19' },
    ],
    featured: false,
  },
  {
    id: 11,
    slug: 'fanren-xiuxian-zhuan',
    title: '凡人修仙传',
    author: '忘语',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20illustration%20of%20an%20ordinary%20looking%20young%20man%20in%20simple%20robe%20holding%20a%20spiritual%20herb%2C%20misty%20mountain%20background%2C%20manga%20cover%20art%2C%20earthy%20green%20and%20brown%20tone%2C%20clean%20composition&width=800&height=1100&seq=comic-fanren-xiuxian&orientation=portrait',
    description: '一个普通的山村穷小子，偶然之下进入了一个江湖小门派，虽然资质平庸，但依靠自身努力和合理算计，最终修炼成仙的故事。',
    category: '修真',
    categorySlug: 'xiuzhen',
    tags: ['修真', '仙侠', '逆袭', '凡人流'],
    status: 'ongoing',
    rating: 9.4,
    views: 11230000,
    chapters: [
      { id: 1, number: 1, title: '第1话 山村少年', updatedAt: '2026-06-30' },
      { id: 2, number: 2, title: '第2话 七玄门', updatedAt: '2026-06-27' },
    ],
    featured: false,
  },
  {
    id: 12,
    slug: 'xiao-ao-jianghu',
    title: '笑傲江湖',
    author: '水墨清风',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20illustration%20of%20a%20free-spirited%20swordsman%20in%20traditional%20Chinese%20clothing%20playing%20flute%2C%20bamboo%20forest%20background%2C%20ink%20wash%20painting%20style%2C%20soft%20green%20and%20white%20tone&width=800&height=1100&seq=comic-xiao-ao-jianghu&orientation=portrait',
    description: '改编自金庸先生经典武侠小说，以漫画形式重新演绎令狐冲的江湖传奇。一曲《笑傲江湖》，道尽江湖恩怨情仇。',
    category: '冒险',
    categorySlug: 'maoxian',
    tags: ['武侠', '冒险', '江湖', '经典'],
    status: 'completed',
    rating: 9.7,
    views: 18900000,
    chapters: [
      { id: 1, number: 1, title: '第1话 华山弟子', updatedAt: '2026-05-01' },
      { id: 2, number: 2, title: '第2话 思过崖', updatedAt: '2026-04-28' },
    ],
    featured: false,
  },
];